import React from 'react'
import { useForm, useFieldArray, Controller } from 'react-hook-form'

let renderCount = 0

type FormValues = {
  test: { firstName: string; lastName: string }[]
}

export const DemoUseFieldArray: React.SFC = () => {
  const { register, control, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: {
      test: [{ firstName: 'Bill', lastName: 'Luo' }],
    },
  })
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: 'test',
  })

  const onSubmit = (data: FormValues) => console.log('data', data)

  // NOTE:
  // Enabling watch will make this component rerender (renderCount increased on every keystroke)

  // if you want to control your fields with watch
  // const watchResult = watch("test");
  // console.log(watchResult);

  // The following is useWatch example
  // console.log(useWatch({ name: 'test', control }))

  renderCount++

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h1>Field Array </h1>
      <p>The following demo allow you to delete, append, prepend items</p>
      <span className="counter">Render Count: {renderCount}</span>
      <ul>
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              <input
                name={`test[${index}].firstName`}
                defaultValue={`${item.firstName}`} // make sure to set up defaultValue
                ref={register()}
              />

              <Controller
                as={<input />}
                name={`test[${index}].lastName`}
                control={control}
                defaultValue={item.lastName} // make sure to set up defaultValue
              />
              <button type="button" onClick={() => remove(index)}>
                Delete
              </button>
            </li>
          )
        })}
      </ul>
      <section>
        <button
          type="button"
          onClick={() => {
            append({ firstName: 'appendBill', lastName: 'appendLuo' })
          }}
        >
          append
        </button>
        <button
          type="button"
          onClick={() =>
            prepend({
              firstName: 'prependFirstName',
              lastName: 'prependLastName',
            })
          }
        >
          prepend
        </button>
        <button
          type="button"
          onClick={() =>
            insert(2, {
              firstName: 'insertFirstName',
              lastName: 'insertLastName',
            })
          }
        >
          insert at
        </button>

        <button type="button" onClick={() => swap(1, 2)}>
          swap
        </button>

        <button type="button" onClick={() => move(1, 2)}>
          move
        </button>

        <button type="button" onClick={() => remove(1)}>
          remove at
        </button>

        <button
          type="button"
          onClick={() =>
            reset({
              test: [{ firstName: 'Bill', lastName: 'Luo' }],
            })
          }
        >
          reset
        </button>
      </section>

      <input type="submit" />
    </form>
  )
}
